import { createRoot } from 'react-dom/client';
import { initializeI18nForUnitTest } from './i18n';
import FreightApp from './federation/federated-app';
import React from 'react';

export default function bootstrap(): void {
  const i18n = initializeI18nForUnitTest();

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error("Root element with id 'root' not found.");
  }
  const root = createRoot(rootElement);
  root.render(<FreightApp i18n={i18n} />);
}
